/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MealAdvise from './meal-advise';
import MealAdviseDetail from './meal-advise-detail';
import MealAdviseUpdate from './meal-advise-update';
import MealAdviseDeleteDialog from './meal-advise-delete-dialog';

const MealAdviseRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MealAdvise />} />
    <Route path="new" element={<MealAdviseUpdate />} />
    <Route path=":id">
      <Route index element={<MealAdviseDetail />} />
      <Route path="edit" element={<MealAdviseUpdate />} />
      <Route path="delete" element={<MealAdviseDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MealAdviseRoutes;
